import styles from "./MediaAndText.module.css";
import NextImage, { StaticImageData } from "next/legacy/image";





type Props = {
  title?: string;
  text?: string;
  timeline?: boolean;
  lastChild?: boolean;
  img: StaticImageData;
};

export const MediaAndText: React.FC<Props> = ({ title, text, timeline, lastChild, img }) => {
  return (
    <div className={`${lastChild ? 'm-0 pb-10 mb-0' : 'm-0 mb-10'} ${styles.innerWrapper}`}>
      <div className={`${styles.innerChild} overflow-hidden rounded-xl mb-3`}>
        <NextImage layout="responsive" alt={"title"} src={img} />
      </div>
      <div className={styles.innerChild}>
        <h3
          className={`mb-2 lrg:mt-auto subhead1 ${styles.subhed} ${
            timeline ? styles.timelineChild : ""
          }`}
        >
          {title}
        </h3>
        <p className={`${styles.text} body1 lrg:mb-auto`}>{text}</p>
      </div>
    </div>
  );
};
